import { createDomain, fork, sample, Scope } from 'effector';
import { createGate } from 'effector-react';
import { signout } from '@features/common';
import { apiRequests } from '../api';
import { DataResponse, Option } from '../types/main';

export const ControlDomain = createDomain();
export const ControlGate = createGate();

export const fxGetData = ControlDomain.createEffect<void, DataResponse, Error>().use(
  apiRequests.getData
);

export const startRequest = ControlDomain.createEvent();

export const $options = ControlDomain.createStore<Option[] | null>(null).reset(
  ControlGate.close,
  signout
);

sample({
  clock: startRequest,
  target: fxGetData,
});

sample({
  clock: fxGetData.doneData,
  fn: ({ currency_list }) =>
    currency_list.map(({ id, title }) => ({
      id: String(id),
      label: title,
    })),
  target: $options,
});

export const scopes: { [key: string]: Scope } = {};

export const createScope = (name: string) => {
  if (scopes[name]) return scopes[name];
  scopes[name] = fork(ControlDomain);

  return scopes[name];
};
